// Form Options Store

const state = {
  formOptions: {},
}

const getters = {}

const actions = {}

const mutations = {
  SET_FORM_OPTIONS: (state, payload) => {
    state.formOptions = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
